<template>
  <el-form
    ref="editForm"
    :model="editForm"
    label-width="80px"
    @submit.prevent="onSubmit"
    style="margin: 20px; width: 60%; min-width: 600px"
  >
    <el-form-item label="我的昵称">
      <el-input v-model="editForm.uRealName"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="newPwd">
      <el-input
        v-model="editForm.newPwd"
        show-password
        auto-complete="off"
        placeholder="如果要修改密码，则输入新密码即可"
      ></el-input>
    </el-form-item>
    <el-form-item label="头像">
      <el-upload
        class="avatar-uploader"
        :action="`${baseApiUrl}/images/Upload/Pic`"
        :show-file-list="false"
        :headers="token"
        :data="ruleForm"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload"
      >
        <img
          v-if="editForm.AvatarUrl"
          :src="editForm.AvatarUrl"
          class="avatar"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon plus-sign"></i>
      </el-upload>
    </el-form-item>

    <el-form-item label="留言/备注">
      <el-input type="textarea" v-model="editForm.uRemark"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button @click="onSubmit" type="primary" :loading="loading">
        更新
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { BaseApiUrl } from "../../api/api";
import * as common from "../../api/common";
export default {
  data() {
    return {
      editForm: {
        id: 0,
        uID: 0,
        RID: 0,
        uLoginName: "",
        uRealName: "",
        newPwd: "",
        name: "",
        sex: -1,
        age: 0,
        birth: "",
        uRemark: "",
        addr: "",
        AvatarUrl: "",
      },
      token: {
        Authorization: "Bearer ",
      },
      ruleForm: {
        max_ver: "",
        min_ver: "",
        enable: "",
      },
      loading: false,
    };
  },
  computed: {
    baseApiUrl() {
      return BaseApiUrl || "";
    },
  },
  methods: {
    onSubmit() {
      if (!this.loading) {
        this.loading = true;
        common
          .updateUserInfo(this.editForm)
          .then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              window.localStorage.user = JSON.stringify(this.editForm);
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLimit = file.size / 1024 / 1024 < 4;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!')
      // }
      if (!isLimit) {
        this.$message.error("上传头像图片大小不能超过 4MB!");
      }
      return isLimit;
    },
    handleAvatarSuccess(res, file) {
      if (res.success) {
        this.editForm.AvatarUrl = `${this.baseApiUrl}/${res.response}`;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
  },
  mounted() {
    let tokenStr = window.localStorage.Token;
    this.token = {
      Authorization: "Bearer " + tokenStr,
    };

    var user = JSON.parse(window.localStorage.user);
    if (user) {
      Object.assign(this.editForm, user);
    }
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  text-align: center;
}
.plus-sign {
  line-height: 120px !important;
}
.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.markdown-body {
  height: 500px !important;
}
</style>
